import React, { useState } from "react";
import {
  DisputeSettlment,
  PublishingSplit,
  usResident,
} from "shared/components/AllDropdownOptions";
import {
  CustomAmountDropdown,
  CustomCheckbox,
  CustomDropDown,
  CustomInput,
  CustomTextArea,
} from "shared/components/allInput";
import CustomButton, {
  CustomButtonOutlined,
} from "shared/components/inputButton";
import formValidation from "utils/validations";

const Publishing = ({ data, setData }) => {
  console.log(data, "data");
  const [writers, setWriters] = useState([{ id: 1 }]);

  const addWriter = () => {
    setWriters([...writers, { id: writers.length + 1 }]);
  };

  const removeWriter = () => {
    if (writers.length > 1) {
      setWriters(writers.slice(0, -1));
    }
  };

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);

    const coWriterMatch = name.match(
      /^(coWriterFullLegalName|coWriterName|coWriterAddress|publisherName|identificationNumber|publisherAddress|cowriterShare)(\d+)$/
    );

    console.log("coWriterMatch", coWriterMatch);
    if (coWriterMatch) {
      const [, field, indexStr] = coWriterMatch;
      console.log("indexStr", indexStr);
      const index = parseInt(indexStr, 10) - 1;

      setData((prev) => {
        const updatedCoWriters = [...(prev.coWriters || [])];
        const updatedErrors = { ...(prev.formErrors || {}) };

        if (!updatedCoWriters[index]) {
          updatedCoWriters[index] = {};
        }

        updatedCoWriters[index][field] = value;

        // Set error message for that field
        if (!updatedErrors.coWriters) updatedErrors.coWriters = [];
        if (!updatedErrors.coWriters[index])
          updatedErrors.coWriters[index] = {};

        updatedErrors.coWriters[index][field] = formErrors[name];

        return {
          ...prev,
          coWriters: updatedCoWriters,
          formErrors: updatedErrors,
        };
      });
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
        formErrors: {
          ...prev.formErrors,
          [name]: formErrors[name],
        },
      }));
    }
  };

  const handleArrayInputChnage = ({ name, value, index }) => {
    const allWriters = [...writers]
    const writer = allWriters[index]
    const formErrors = formValidation(name, value, writer);
    allWriters[index] = {...allWriters[index], [name]: value, formErrors}
    setWriters(allWriters)
  };

  return (
    <>
      <div className="w-6">
        <h4 className="text-xl">Draft an Agreement</h4>
        <CustomInput
          data={data}
          name="agreementName"
          label="Name of Agreement"
          ignoreLabel
          col={12}
          onChange={handleChange}
        />
      </div>
      <div>
        <h5 className="text-xl font-medium">Primary Artist Name</h5>
        <div className="grid mt-3 align-items-center">
          <CustomInput
            name="fullLegalName"
            data={data}
            col={5}
            onChange={handleChange}
            label="Artist Full Legal Name"
          />
          <div className="col text-center">p/k/a</div>
          <CustomInput
            data={data}
            label="Artist Name"
            col={5}
            name="name"
            onChange={handleChange}
          />
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Primary Artist Address</h5>
            <label className="text-gray-500 mb-0" htmlFor="">
              Unit Number, Street Number, City, State, Zip Code
            </label>
            <CustomTextArea
              col={12}
              className="w-full "
              rows={5}
              cols={30}
              data={data}
              ignoreLabel
              name="address"
              onChange={handleChange}
            />
          </div>
          <div className="col-12">
            <h5 className="text-xl font-medium mb-3">
              Artist's Publisher Information
            </h5>
          </div>
          <CustomInput
            label="Publisher Name"
            col={6}
            data={data}
            name="artistPublisherName"
            onChange={handleChange}
          />
          <CustomInput
            label="Publishing Identification Number"
            col={6}
            data={data}
            name="artistIdentificationNumber"
            onChange={handleChange}
          />
          <CustomTextArea
            col={12}
            className="w-full"
            rows={5}
            cols={30}
            data={data}
            name="artistPublisherAddress"
            label={`Address of Publisher`}
            placeholder="Enter address"
            onChange={handleChange}
          />
          <CustomAmountDropdown
            name="artistShare"
            data={data}
            className="w-full col-12 "
            onChange={handleChange}
            showPercentageSymbol={true}
            inputplaceholder="Enter percentage"
          />

          {writers.map((writer, index) => (
            <div key={writer.id} className="border-top-3 border-gray-300 pt-4">
              <label htmlFor="" className="text-xl font-semibold">
                Co-Writer Full Legal Name #{writer.id}{" "}
              </label>
              <div className="flex align-items-center flex-wrap ">
                <CustomInput
                  name="coWriterFullLegalName"
                  data={writer}
                  label="Co-Writer Legal Name"
                  col={5}
                  onChange={({name, value}) => handleArrayInputChnage({name: name, value: value, index: index})}
                />
                <div className="col text-center">p/k/a</div>
                <CustomInput
                  name="coWriterName"
                  data={data}
                  placeholder="Enter name"
                  label="Co-Writer Name"
                  col={5}
                   onChange={({name, value}) => handleArrayInputChnage({name: name, value: value, index: index})}
                />
                <CustomTextArea
                  col={12}
                  className="w-full"
                  rows={5}
                  cols={30}
                  data={data}
                  label="Co-Writer Address"
                  name={`coWriterAddress${writer.id}`}
                  placeholder="Enter address"
                  onChange={handleChange}
                />
                <div className="col-12">
                  <h5 className="text-xl font-medium mb-3">
                    Co-Writer #{writer.id} Publisher Information
                  </h5>
                </div>
                <CustomInput
                  label="Publisher Name"
                  col={6}
                  data={data}
                  name="publisherName"
                  onChange={handleChange}
                />
                <CustomInput
                  label="Publishing Identification Number"
                  col={6}
                  data={data}
                  name={`identificationNumber${writer.id}`}
                  onChange={handleChange}
                />
                <CustomTextArea
                  col={12}
                  className="w-full"
                  rows={5}
                  cols={30}
                  data={data}
                  name={`publisherAddress${writer.id}`}
                  label={`Address of Publisher`}
                  placeholder="Enter address"
                  onChange={handleChange}
                />
                <CustomAmountDropdown
                  name="cowriterShare"
                  data={data}
                  className="w-full col-12"
                  onChange={handleChange}
                  showPercentageSymbol={true}
                  inputplaceholder="Enter percentage"
                />
              </div>
            </div>
          ))}

          <div className="flex gap-3 justify-content-end align-items-center mb-3">
            <CustomButton label="Add Co-Writer" onClick={addWriter} />
            {writers.length > 1 && (
              <CustomButtonOutlined
                label="Remove Co-Writer"
                onClick={removeWriter}
              />
            )}
          </div>
          <div className="md:col-12 px-0">
            <h5 className="text-xl font-medium mb-2">
              Other Clauses to Add/Consider
            </h5>
            <p className="mb-3">
              Add any clauses that may be needed for your contract.
            </p>
            <div className="md:col-6 p-0">
              <CustomDropDown
                options={PublishingSplit}
                optionLabel="name"
                data={data}
                col={12}
                placeholder="No"
                name="disputeSettlement"
                onChange={handleChange}
                label="Are you operating under U.S. jurisdiction?"
                extraClassName="p-0 pb-4"
              />
              {data.disputeSettlement === "Yes" && (
                <div className="md:col-12 px-0">
                  <CustomInput
                    data={data}
                    label="Controlled Composition Rate"
                    col={6}
                    name="controlledComposition"
                    onChange={handleChange}
                    placeholder="75% of the satutory rate"
                  />
                </div>
              )}
              <label htmlFor="" className="mt-2 font-semibold">
                2. Compiance with Statutory Requirement
              </label>
              <CustomCheckbox label="I accept" extraClassName="p-0" checked />
              <CustomTextArea
                className="bg-white w-full"
                col={12}
                data={data}
                placeholder="Any other comments"
                name="satutoryRequirement"
                onChange={handleChange}
              />
              <label htmlFor="" className="font-semibold">
                3. Notification and Approval
              </label>
              <p className="p-2 pl-3">
                How many days are required for co-writers to respond for usages
                of the Composition
              </p>
              <CustomInput
                name="approvalTimeframe"
                data={data}
                onChange={handleChange}
                placeholder="Enter Approval Timeframe"
                className="w-full"
                extraClassName="p-0 ml-3"
                col={12}
              />
              <CustomButton label="Generate Contract" extraClassName="ml-3" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Publishing;
